import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeCardSkeleton } from './TypeCard';
import type { TypeCtaSkeleton } from './TypeCta';

export interface TypeBlockPromoFields {
    internalName: EntryFieldTypes.Symbol;
    visibility?: EntryFieldTypes.Symbol<'loggedIn' | 'loggedOut'>;
    title?: EntryFieldTypes.Symbol;
    displayOption?: EntryFieldTypes.Symbol<
        '1:1 landscape' | '1:1 portrait' | '1:1:1' | '1:2' | '1:3' | '2:2' | 'standalone'
    >;
    colorOption?: EntryFieldTypes.Symbol<'color-black' | 'color-dark-purple' | 'color-light-purple'>;
    cards?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeCardSkeleton>>;
    cta?: EntryFieldTypes.EntryLink<TypeCtaSkeleton>;
}

export type TypeBlockPromoSkeleton = EntrySkeletonType<TypeBlockPromoFields, 'blockPromo'>;
export type TypeBlockPromo<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockPromoSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockPromo<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockPromo<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockPromo';
}
